import React, { Component } from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'Use Cases | Canny';
const Description = 'See the different ways Canny can benefit your business.';
const Image = 'https://canny.io/images/canny-social.png';
const UseCasesUrl = 'https://canny.io/use-cases';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${UseCasesUrl}#webpage`,
    url: UseCasesUrl,
    name: 'Use Cases - Canny',
    description:
      'Explore how Canny helps teams collect feedback, prioritize roadmaps, announce updates, and drive engagement across multiple use cases.',
    inLanguage: 'en',
    about: { '@id': 'https://canny.io/#app' },
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createWebApplicationItemList(`${UseCasesUrl}#list`, 'Canny Use Cases', [
    {
      name: 'Feature Request Management',
      url: 'https://canny.io/use-cases/feature-request-management',
      description:
        'Collect, organize, and prioritize feature requests to build customer-driven products.',
    },
    {
      name: 'Idea Management',
      url: 'https://canny.io/use-cases/idea-management',
      description:
        'Capture, evaluate, and prioritize ideas to turn input into actionable initiatives.',
    },
    {
      name: 'Internal Feedback',
      url: 'https://canny.io/use-cases/internal-feedback',
      description: 'Centralize internal requests and align them with product planning.',
    },
    {
      name: 'Product Management',
      url: 'https://canny.io/use-cases/product-management',
      description: 'Collect feedback, prioritize features, and communicate your roadmap.',
    },
    {
      name: 'Sales Documentation',
      url: 'https://canny.io/use-cases/sales-documentation',
      description: 'Track sales-requested collateral and keep enablement materials up to date.',
    },
    {
      name: 'Public Roadmap',
      url: 'https://canny.io/use-cases/public-roadmap',
      description: 'Share plans publicly, collect feedback on roadmap items, and build trust.',
    },
    {
      name: 'Bug Tracking Tool',
      url: 'https://canny.io/use-cases/bug-tracking-tool',
      description: 'Log, prioritize, and resolve bugs while linking them to customer feedback.',
    },
    {
      name: 'Enterprise Feedback Management',
      url: 'https://canny.io/use-cases/enterprise-feedback-management',
      description:
        'Secure collection, advanced segmentation, and workflow integrations for large orgs.',
    },
    {
      name: 'Customer Feedback Management',
      url: 'https://canny.io/use-cases/customer-feedback',
      description: 'Collect, segment, and analyze feedback from multiple channels; close the loop.',
    },
  ]),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Use Cases', item: UseCasesUrl },
  ]),
]);

export default class LandingUseCasesHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: UseCasesUrl },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}>
        <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
      </Helmet>
    );
  }
}
